import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export const useSelectorProps = () => {
  const location = useLocation();
  const params = useParams();

  const selectorProps = useMemo(() => ({ location, params }), [
    location,
    params,
  ]);

  return selectorProps;
};

export default useSelectorProps;
